import React from 'react';

export const GATEWAYS_INFO = {
    header: <h2>Gateways</h2>,
    body: (
        <>
            <p>Gateways manage the ingress traffic for running services.</p>
            <p>
                To learn more about gateways, see the{' '}
                <a href={'https://dstack.ai/docs/concepts/gateways'} target="_blank">
                    documentation
                </a>
                .
            </p>
        </>
    ),
};
